import { message } from 'antd';
import { createAsyncAction } from 'react-redux-await-control';
import { telli } from '~/services';
import { endpoint } from '~/store';

export const getConcession = createAsyncAction('GET_CONCESSION_REQUEST', {
  saveResult: true,
  context: {
    request: ({ personId }) =>
      telli.get(`${endpoint}/admin/personcustom/people/${personId}/concession`, {
        responseType: 'blob',
      }),
    responseParser: (response) => {
      if (response.status !== 200) {
        throw new Error('Bad response from server.');
      }

      return response.data;
    },
    onRequestSuccess: () => message.success('Carta de concessão requisitada com sucesso.'),
    onRequestError: () => message.error('Falha ao requisitar carta de concessão.'),
  },
});
